import { useState, useMemo, useCallback } from "react";
import useStore from "../../lib/Store/useStore";
import { getFlagEmoji } from "../../utils/countryUtils";

export const useCountryData = () => {
    const { changeCurrency, countriesRates } = useStore();

    const [selectedCountry, setSelectedCountry] = useState("");
    const [flag, setFlag] = useState("");

    const handleCountryChange = useCallback(
        (country) => {
            setSelectedCountry(country);
            const selectedCountryData = countriesRates.find(
                (obj) =>
                    obj?.iso_alpha_2?.toLowerCase() === country?.toLowerCase()
            );

            const data = {
                country: selectedCountryData?.country,
                flag: selectedCountryData?.iso_alpha_2,
                currency: selectedCountryData?.code,
                price: selectedCountryData?.subscription_rate,
                exchangeRate: selectedCountryData?.exchangeRate
            };

            setFlag(getFlagEmoji(selectedCountryData?.iso_alpha_2));
            changeCurrency(data);
        },
        [countriesRates, changeCurrency]
    );

    return {
        countriesRates,
        selectedCountry,
        setSelectedCountry,
        flag,
        setFlag,
        handleCountryChange,
    };
};
